import { sameId, type TaskRow } from './types';

/**
 * PIYASA SATIRINDAKI TEKLIF KIMIN? (2026-10-03, bir buro bir teklif)
 *
 * Bir buro (organizasyon) bir talebe en fazla BIR canli teklif verir. Sunucu piyasa satirina
 * BURONUN teklifini koyuyor: cagiranin kendi teklifi oncelikli, yoksa organizasyonun herhangi
 * bir uyesinin canli teklifi (`offerUserId` / `offerPrice`). Is arkadasi teklif vermisse ikinci
 * teklif verilemez; ayni `POST /v1/offers` o teklifi GUNCELLER ve `editOffer` ister. Yetkisi
 * olmayan eleman 403 `ORGANIZATION_OFFER_EXISTS` alir.
 *
 *   'none'      : buronun bu talepte teklifi yok -> "Teklif ver" (`createOffer`)
 *   'mine'      : teklif cagiranin -> "Guncelle"; metinler eskisi gibi
 *   'colleague' : teklif is arkadasinin -> "Buronuzun teklifi" + "Buronun teklifini guncelle"
 *                 (`editOffer`); yetki yoksa dugme yerine not
 *
 * Kimlikler pg int8 STRING: karsilastirma `sameId` ile. Oturum kimligi bilinmiyorsa 'mine'
 * (eski davranis: satirdaki teklif cagiraninki sayilirdi) — "is arkadasi" demek icin kim
 * oldugumuzu bilmek gerekir.
 */
export type OfferOwnership = 'none' | 'mine' | 'colleague';

export const offerOwnership = (
  row: Pick<TaskRow, 'offerUserId'>,
  myId: string | null | undefined,
): OfferOwnership => {
  if (row.offerUserId === null) return 'none';
  if (!myId || sameId(row.offerUserId, myId)) return 'mine';
  return 'colleague';
};

/**
 * "Son guncelleyen" satirinin adi; satir cizilmeyecekse null.
 *
 * Is arkadasinin teklifinde (sunucu gonderdiyse) her zaman. KENDI teklifimde yalniz baska biri
 * son yazdiysa: teklifin sahibi ilk veren kalir (K1), yani is arkadasi benim teklifimi
 * guncelleyebilir ve "Verdigim fiyat" artik benim yazdigim fiyat olmayabilir. Teklifi son
 * yazan bensem satir gereksiz (eski gorunum aynen kalir). Eski sunucu ad gondermez: null.
 */
export const offerLastWriterName = (
  row: Pick<TaskRow, 'offerUserId' | 'offerByUserId' | 'offerByName'>,
  myId: string | null | undefined,
): string | null => {
  if (row.offerByName === null) return null;
  const ownership = offerOwnership(row, myId);
  if (ownership === 'none') return null;
  if (ownership === 'colleague') return row.offerByName;
  return row.offerByUserId !== null && !sameId(row.offerByUserId, myId) ? row.offerByName : null;
};
